import React from 'react';
import { Card, Grid, Button, InputAdornment, Typography } from "@mui/material";
import SearchField from '../../overrides/longSearchField'
import SearchIcon from "@mui/icons-material/Search";
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import { ExportCsv } from "@material-table/exporters";

const KioskHeader = ({ handleSearch, searchText, rowData, columnData }) => {

    return (
        <>
            <Card style={{ boxShadow: (theme) => `0px 12px 23px ${theme.palette.grey[200]}`, borderRadius: "20px 20px 0px 0px" }}>
                <Grid container spacing={5} sx={{ padding: '30px', display: 'flex' }} >
                    <Grid item lg={9} xs={12} md={9} sm={8} >
                        <SearchField
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    height: '50px',

                                }
                            }}
                            placeholder='Search'
                            fullWidth
                            onChange={handleSearch}
                            value={searchText} />
                    </Grid>
                    <Grid item lg={3} xs={12} md={3} sm={4} >

                        <Button variant='contained' sx={{ height: '50px' }} fullWidth endIcon={<DoubleArrowIcon />} onClick={() => ExportCsv(columnData, rowData, "Kiosk Orders")}>
                            <Typography variant='t16_500'>Export to Excel</Typography>
                        </Button>

                    </Grid>
                </Grid>
            </Card>
        </>
    )
}

export default KioskHeader;